import Pusher from 'pusher-js';
import { WS_URL } from './constants';

const pusher = new Pusher('app_key', {
    wsHost: WS_URL,
    enabledTransports: ['ws'],
});

export default pusher;
